/*
 * <<
 * Davinci
 * ==
 * Copyright (C) 2016 - 2017 EDP
 * ==
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * >>
 */

import React from 'react'
import {WechatScanLoginFormPropsType, withWechatScanLoginForm} from "../../hoc/withWechatScanLoginForm";
import {useIntl} from "react-intl";

const BasWechatScanLoginForm: React.FC<WechatScanLoginFormPropsType> = (props) => {
    let intl = useIntl();
    return (
        <>
            <iframe style={{height: '400px', transform: 'scale(0.6, 0.6)', marginLeft: '100px'}} title={intl.formatMessage({id: "微信二维码"})}
                    frameBorder="no"
                    marginWidth={0}
                    marginHeight={0}
                    scrolling="no"
                    sandbox={'allow-forms allow-scripts allow-top-navigation allow-same-origin'}
                    src={props.url}/>

        </>
    )
}

export default withWechatScanLoginForm(BasWechatScanLoginForm)
